import Chips from 'components/field/Chips';

import * as S from './FilterInput.styled';

/**
 * @author Burak Unsal
 */
const DynamicListChips = (props) => {
	const { value, onChange, ...moreProps } = props;

	return (
		<S.InputContainer {...moreProps}>
			<Chips value={value === '' ? null : value} setValue={onChange} autoFocus />
		</S.InputContainer>
	);
};

export default DynamicListChips;
